import { store } from "../../../../../../stateManagement/store"
import { setCustomMapFilterString } from "../../../../../../stateManagement/reducers/custom/CustomMapSlice"

export function configureAndSetCustomMapFilters(appliedFilters: any) {
    let layerFilterArray: any = []
    Object.entries(appliedFilters).map(([fieldName, filterOptions]: any) => {
        const { filterForm, filterType, valueType } = filterOptions
        if (filterForm === 'input') {
            const { value, [`ignore-${fieldName}`]: ignoreFilter } = filterOptions
            if (filterType === 'equals') {
                let filterString = ''
                if (!ignoreFilter) {
                    filterString += value ? `${fieldName}=${value}` : `${fieldName} IS NULL`
                }
                if (filterString) {
                    layerFilterArray.push(filterString)
                }
            }
        }
        if (filterForm === 'list-checkbox') {
            const { listValues } = filterOptions
            if (filterType === 'equals') {
                let filterString = ''
                if (listValues && !listValues[`ignore-${fieldName}`]) {
                    let activeListCheckboxValues = Object.entries(listValues).filter(([value, checked]) => (checked === true && value !== `null-${fieldName}`)).map(([key, value]) => key)
                    if (activeListCheckboxValues.length === 0) {
                        if (!listValues[`null-${fieldName}`]) {
                            filterString += `(${fieldName} IS NULL and ${fieldName} IS NOT NULL)`
                        } else {
                            filterString += `(${fieldName} IS NULL)`
                        }
                    } else {
                        if (valueType === 'string') {
                            activeListCheckboxValues = activeListCheckboxValues.map((filterValue: any) => `'${filterValue}'`)
                        }
                        filterString += `(${fieldName} in (${activeListCheckboxValues?.join(',')})`
                        if (listValues[`null-${fieldName}`]) {
                            filterString += ` or ${fieldName} IS NULL)`
                        } else {
                            filterString += ')'
                        }
                    }
                }
                if (filterString) {
                    layerFilterArray.push(filterString)
                }
            }
        }
        if (filterForm === 'tree-checkbox') {
            const { treeValues } = filterOptions
            if (filterType === 'equals') {
                let filterString = ''
                if (treeValues && !treeValues[`ignore-${fieldName}`]) {
                    let activeListCheckboxValues = Object.entries(treeValues).filter(([value, checked]) => (checked === true && value !== `null-${fieldName}`)).map(([key, value]) => key)
                    if (activeListCheckboxValues.length === 0) {
                        if (!treeValues[`null-${fieldName}`]) {
                            filterString += `(${fieldName} IS NULL and ${fieldName} IS NOT NULL)`
                        } else {
                            filterString += `(${fieldName} IS NULL)`
                        }
                    } else {
                        if (valueType === 'string') {
                            activeListCheckboxValues = activeListCheckboxValues.map((filterValue: any) => `'${filterValue}'`)
                        }
                        filterString += `(${fieldName} in (${activeListCheckboxValues?.join(',')})`
                        if (treeValues[`null-${fieldName}`]) {
                            filterString += ` or ${fieldName} IS NULL)`
                        } else {
                            filterString += ')'
                        }
                    }
                }
                if (filterString) {
                    layerFilterArray.push(filterString)
                }
            }
        }
        if (filterForm === 'calendar') {
            if (filterType === 'between') {
                const { minValue, maxValue, [`ignore-${fieldName}`]: ignoreFilter } = filterOptions ?? {}
                let filterString = ''
                if (minValue && maxValue && !ignoreFilter) {
                    filterString = `${fieldName}>=${minValue} and ${fieldName}<=${maxValue}`
                    layerFilterArray.push(filterString)
                }
            }
            if (filterType === 'from') {
                const { value, [`ignore-${fieldName}`]: ignoreFilter } = filterOptions ?? {}
                let filterString = ''
                if (value && !ignoreFilter) {
                    filterString = `${fieldName}>=${value}`
                    layerFilterArray.push(filterString)
                }
            }
        }
    })
    let mapFilterString = layerFilterArray.join(' and ')
    store.dispatch(setCustomMapFilterString(mapFilterString))
}